import React, { useState , useEffect} from "react";
import styles from "./header.module.scss";
import user from "../../app/images/user.png";
import logo from "../../app/images/logo.png";
import listIcon from "../../app/images/list.png";
import bellIcon from "../../app/images/bellRinging.png";
import Drawer from '@mui/material/Drawer';
import houseIcon from "../../app/images/house.png";
import chartIcon from "../../app/images/chartLine.png";
import settingsIcon from "../../app/images/settings.png";
import logoutIcon from "../../app/images/signOut.png";
import { NavLink } from "react-router-dom";
import arrowRight from "../../app/images/icon.png";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [userId, setUserId] = useState<string | null>(localStorage.getItem("userId") );
  const [userImage, setUserImage] = useState<string | null>(null);
  const API_BASE_URL = "https://api.drymatec.de/api/user";

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const base64Payload = token.split(".")[1];
        if (!base64Payload) throw new Error("Invalid token format");

        const decodedPayload = JSON.parse(atob(base64Payload));

        if (decodedPayload?.id) {
          setUserId(decodedPayload.id);
          localStorage.setItem("userId", decodedPayload.id);
        } else {
          console.warn("User ID not found in token payload");
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  useEffect(() => {
    const fetchUserImage = async () => {
      if (!userId) return;

      try {
        const response = await axios.get(`${API_BASE_URL}/${userId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const { image } = response.data;
        setUserImage(image);
      } catch (error: any) {
        console.error(
          "Error fetching user image:",
          error.response?.data || error.message
        );
      }
    };

    fetchUserImage();
  }, [userId]);


  const handleLogout = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("No token found. Redirecting to login.");
        navigate("/login");
        return;
      }

      await axios.get("https://api.drymatec.de/api/logout", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      navigate("/login");
    } catch (err: any) {
      console.error("Logout error:", err.response?.data || err.message);
      if (err.response?.status === 401) {
        alert("Session expired. Please log in again.");
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        navigate("/login");
      } else {
        alert(err.response?.data?.message || "Logout failed. Please try again.");
      }
    }
  };
  const DrawerList = (
    <div className={styles.drawerList} role="presentation" onClick={toggleDrawer(false)}>
      <div className={styles.logoBox}>
        <img src={logo} alt="logo"/>
      </div>
      <NavLink className={styles.navLink} to="">
        <div className={styles.navLinkWrap}>
          <img src={houseIcon}/>
          <p>Home</p>
        </div>
        <img src={arrowRight}/>
      </NavLink>
      <NavLink className={styles.navLink} to="/historicaltrend">
        <div className={styles.navLinkWrap}>
          <img src={chartIcon}/>
          <p>Historical Trend</p>
        </div>
        <img src={arrowRight}/>
      </NavLink>
      {/* <NavLink className={styles.navLink} to="">
        <div className={styles.navLinkWrap}>
          <img src={bellIcon}/>
          <p>Notifications</p>
        </div>
        <img src={arrowRight}/>
      </NavLink> */}
      <NavLink className={styles.navLink} to="/profile">
        <div className={styles.navLinkWrap}>
          <img src={settingsIcon}/>
          <p>Settings</p>
        </div>
        <img src={arrowRight}/>
      </NavLink>
      <NavLink  onClick={handleLogout} className={styles.navLink} to="">
        <div className={styles.navLinkWrap}>
          <img src={logoutIcon}/>
          <p>Log Out</p>
        </div>
        <img src={arrowRight}/>
      </NavLink>
    </div>
  );


  return (
   <div className={styles.wrapper}>
      <div className={styles.wrapperInner}>
        <button onClick={toggleDrawer(true)} className={styles.headerBtn}>
          <img src={listIcon} alt="listIcon"/>
        </button>
        <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
        <div className={styles.wrpperRight}>
          <button className={styles.headerBtn}>
            <img src={bellIcon} alt="bellIcon"/>
          </button>
          <button className={styles.headerUser}>
            <img src={userImage || user} alt="user"/>
          </button>
        </div>
      </div>
   </div>
  );
};

export default Header;
